// color config
import {
  textTitleMyLearningJourney,
  colorTextDesc,
  colorTextTitleMobile,
} from "../../../../../../../config/constant/color/index";

const styles = {
  courseWrapper: {
    margin: "40px",
  },
  wrapperStyleMobile: {
    margin: 0,
  },
  rowImageStyleMobile: {
    width: "100%",
    height: "160px",
  },
  imageThumbnailMobile: {
    // borderRadius: '8px',
    objectFit: "cover",
    height: "100%",
  },
  divRightStyleMobile: {
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: "20px 18px",
  },
  pProgramStyleMobile: {
    fontSize: "10px",
    marginBottom: "10px",
    fontWeight: "400",
    color: colorTextDesc,
  },
  titleCourseDescStyleMobile: {
    fontSize: "18px",
    fontWeight: "500",
    color: colorTextTitleMobile,
  },
  rowBottomSecondStyleMobile: {
    display: "flex",
    alignItems: "flex-end",
  },
  dividerStyle: {
    margin: "20px 0",
  },
  courseNameWrapper: {
    marginRight: "20px",
  },
  textCourse: {
    fontSize: "12px",
    fontWeight: "400",
    marginBottom: "10px",
  },
  textCourseSkeleton: {
    minWidth: "70px",
  },
  courseName: {
    fontSize: "22px",
    fontWeight: "500",
    color: textTitleMyLearningJourney,
  },
  courseNameSkeleton: {
    minWidth: "300px",
    display: "flex",
  },
  divider: {
    margin: "20px 0",
  },
  courseDesc: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "1.4",
    marginRight: "20px",
    textAlign: "left",
    whiteSpace: "pre-wrap",
  },
  courseImageSkeleton: {
    width: "209px",
    height: "143px",
    borderRadius: "8px",
  },
  courseImage: {
    borderRadius: "8px",
    objectFit: "cover",
  },
  divStyle: {
    width: "209px",
    minWidth: "209px",
  },
};

export default styles;
